

// import axios from 'axios';
// import React, { useState } from 'react';
// import { useEffect } from 'react';
// import {
//   Container, Row, Col, Card, Form, Table, Tabs, Tab
// } from 'react-bootstrap';
// import {
//   FaGavel, FaUsers, FaDollarSign, FaUsersCog
// } from 'react-icons/fa';
// import {
//   LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend
// } from 'recharts';

// const allMonths = [
//   'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
//   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
// ];

// const yearlyRevenue = {
//   2024: [
//     { name: 'Jan', value: 400 },
//     { name: 'Feb', value: 300 },
//     { name: 'Mar', value: 200 },
//     { name: 'Apr', value: 278 },
//     { name: 'May', value: 189 },
//     { name: 'Jun', value: 239 },
//     { name: 'Jul', value: 349 },
//   ],
//   2025: [
//     { name: 'Jan', value: 100 },
//     { name: 'Feb', value: 250 },
//     { name: 'Mar', value: 350 },
//     { name: 'Apr', value: 300 },
//     { name: 'May', value: 220 },
//     { name: 'Jun', value: 260 },
//     { name: 'Jul', value: 400 },
//     { name: 'Aug', value: 430 },
//     { name: 'Sep', value: 390 },
//     { name: 'Oct', value: 690 },
//     { name: 'Nov', value: 490 },
//     { name: 'Dec', value: 890 },
//   ],
// };

// const allBids = [
//   {
//     id: 'BID001',
//     product: 'Laptop',
//     price: '₹45,000',
//     createdAt: '2025-05-01',
//     closedAt: '2025-05-10',
//     status: 'success',
//   },
//   {
//     id: 'BID002',
//     product: 'Smartphone',
//     price: '₹22,000',
//     createdAt: '2025-04-20',
//     closedAt: '2025-04-28',
//     status: 'expired',
//   },
//   {
//     id: 'BID003',
//     product: 'Printer',
//     price: '₹7,500',
//     createdAt: '2025-06-01',
//     closedAt: '2025-06-04',
//     status: 'open',
//   },
// ];

// const filterBids = (status) => {
//   if (status === 'all') return allBids;
//   return allBids.filter(bid => bid.status === status);
// };

// function BidTable({ data }) {
//   return (
//     <div style={{ overflowX: 'auto' }}>
//       <Table responsive bordered hover>
//         <thead className="table-dark">
//           <tr>
//             <th>Bid ID</th>
//             <th>Product Name</th>
//             <th>Bid Price</th>
//             <th>Created Date</th>
//             <th>Closed Date</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.length === 0 ? (
//             <tr>
//               <td colSpan="5" className="text-center text-muted">No bids found.</td>
//             </tr>
//           ) : (
//             data.map((bid, index) => (
//               <tr key={index}>
//                 <td>{bid.id}</td>
//                 <td>{bid.product}</td>
//                 <td>{bid.price}</td>
//                 <td>{bid.createdAt}</td>
//                 <td>{bid.closedAt}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </Table>
//     </div>
//   );
// }

// export default function AdminDashboard() {

//   const [statsData, setStatsData] = useState({
//     totalBids: 0,
//     totalRevenue: 0,
//     totalBuyers: 0,
//     totalSellers: 0,
//   });

//   useEffect(() => {
//     const fetchStats = async () => {
//       try {
//         const res = await axios.get('https://vyaparapi.emedha.in/api/admin/admin-dashboard-stats');
//         setStatsData(res.data);
//       } catch (err) {
//         console.error('Failed to fetch stats:', err);
//       }
//     };

//     fetchStats();
//   }, []);

//   const stats = [
//     { title: 'Total Bids',  value: statsData.totalBids.toLocaleString(), icon: <FaGavel size={28} />, bg: '#062d59' },
//     { title: 'Total Revenue', value: `₹${statsData.totalRevenue.toLocaleString()}`, icon: <FaDollarSign size={28} />, bg: 'linear-gradient(135deg, #062d59, #274c87)' },
//     { title: 'Total Buyers', value: statsData.totalBuyers.toLocaleString(), icon: <FaUsers size={28} />, bg: '#e3080c' },
//     { title: 'Total Sellers',  value: statsData.totalSellers.toLocaleString(), icon: <FaUsers size={28} />, bg: 'linear-gradient(135deg, #e3080c, #f14b4e)' },
//   ];

//   const availableYears = Object.keys(yearlyRevenue).sort();
//   const [selectedYear, setSelectedYear] = useState(availableYears[availableYears.length - 1]);

//   const selectedYearDataRaw = yearlyRevenue[selectedYear] || [];
//   const selectedYearData = allMonths.map(month => {
//     const found = selectedYearDataRaw.find(d => d.name === month);
//     return { name: month, value: found ? found.value : 0 };
//   });

//   const userDistribution = [
//     { name: 'Buyers', value: 800 },
//     { name: 'Sellers', value: 400 },
//   ];
//   const pieColors = ['#062d59', '#e3080c'];

//   return (
// <div style={{
//   backgroundColor: '#ffffff',
//   minHeight: '100vh',
//   paddingTop: '30px',
//   paddingBottom: '30px',
//   boxShadow: `
//     0 0 16px rgba(6, 45, 89, 0.35),    /* #062d59 */
//     0 0 12px rgba(227, 8, 12, 0.25)     /* #e3080c */
//   `,
//   borderRadius: '12px',

// }}>

//     <Container className="my-1">
//       <h3 className="text-center mb-4 fw-bold" style={{ color: '#062d59' }}>
//         📊 Admin Dashboard
//       </h3>

//       {/* Stats Cards */}
//       <Row>
//         {stats.map((stat, idx) => (
//           <Col md={6} lg={3} key={idx} className="mb-4">
//             <Card className="text-white border-0 shadow-sm" style={{ background: stat.bg, borderRadius: '15px' }}>
//               <Card.Body className="d-flex flex-column justify-content-between p-4" style={{ minHeight: '150px' }}>
//                 <div className="d-flex align-items-center mb-3">
//                   <div className="bg-white text-dark rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 44, height: 44 }}>
//                     {stat.icon}
//                   </div>
//                   <div>
//                     <div className="text-uppercase fw-semibold small">{stat.title}</div>
//                   </div>
//                 </div>
//                 <h4 className="fw-bold d-flex align-items-center justify-content-center">{stat.value}</h4>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))}
//       </Row>

//       {/* Charts Row */}
//       <Row  className="shadow-sm border-0 pt-3" style={{ backgroundColor: '#f8f9fc', borderRadius: '12px' }}>
//         <Col md={7} className="mb-4">
//           <Card className="shadow-sm border-0">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="fw-bold mb-0" style={{ color: '#062d59' }}>
//                   📈 Monthly Revenue Trend
//                 </h5>
//                 <Form.Select
//                   size="sm"
//                   style={{ width: '100px' }}
//                   value={selectedYear}
//                   onChange={e => setSelectedYear(e.target.value)}
//                 >
//                   {availableYears.map(y => <option key={y} value={y}>{y}</option>)}
//                 </Form.Select>
//               </div>

//               <ResponsiveContainer width="100%" height={300}>
//                 <LineChart data={selectedYearData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" />
//                   <YAxis />
//                   <Tooltip />
//                   <Line type="monotone" dataKey="value" stroke="#e3080c" strokeWidth={2} activeDot={{ r: 6 }} />
//                 </LineChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={5} className="mb-4">
//           <Card className="shadow-sm border-0">
//             <Card.Body>
//               <h5 className="fw-bold mb-4" style={{ color: '#062d59' }}>
//                 <FaUsersCog className="me-2" /> User Distribution
//               </h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <PieChart>
//                   <Pie
//                     data={userDistribution}
//                     dataKey="value"
//                     nameKey="name"
//                     cx="50%"
//                     cy="50%"
//                     outerRadius={100}
//                     label
//                   >
//                     {userDistribution.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
//                     ))}
//                   </Pie>
//                   <Legend verticalAlign="bottom" height={36} />
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Tabs with Bid Table */}
//       <Card className="shadow-sm border-0 mt-4">
//         <Card.Body>
//           <h5 className="fw-bold mb-3" style={{ color: '#062d59' }}>📋 Bid Overview</h5>
//           <Tabs defaultActiveKey="all" id="bid-tabs" className="mb-3" justify>
//             <Tab eventKey="all" title="All Bids">
//               <BidTable data={filterBids('all')} />
//             </Tab>
//             <Tab eventKey="success" title="Success Bids">
//               <BidTable data={filterBids('success')} />
//             </Tab>
//             <Tab eventKey="expired" title="Expired Bids">
//               <BidTable data={filterBids('expired')} />
//             </Tab>
//           </Tabs>
//         </Card.Body>
//       </Card>
//     </Container>
//     </div>
//   );
// }





import axios from 'axios';
import React, { useState } from 'react';
import { useEffect } from 'react';
import {
  Container, Row, Col, Card, Form, Table, Tabs, Tab
} from 'react-bootstrap';
import {
  FaGavel, FaUsers, FaDollarSign, FaUsersCog
} from 'react-icons/fa';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Legend
} from 'recharts';

const allMonths = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];


const allBids = [
  {
    id: 'BID001',
    product: 'Laptop',
    price: '₹45,000',
    createdAt: '2025-05-01',
    closedAt: '2025-05-10',
    status: 'success',
  },
  {
    id: 'BID002',
    product: 'Smartphone',
    price: '₹22,000',
    createdAt: '2025-04-20',
    closedAt: '2025-04-28',
    status: 'expired',
  },
  {
    id: 'BID003',
    product: 'Printer',
    price: '₹7,500',
    createdAt: '2025-06-01',
    closedAt: '2025-06-04',
    status: 'open',
  },
];

const filterBids = (status) => {
  if (status === 'all') return allBids;
  return allBids.filter(bid => bid.status === status);
};

// function BidTable({ data }) {
//   return (
//     <div style={{ overflowX: 'auto' }}>
//       <Table responsive bordered hover>
//         <thead className="table-dark">
//           <tr>
//             <th>Bid ID</th>
//             <th>Product Name</th>
//             <th>Bid Price</th>
//             <th>Created Date</th>
//             <th>Closed Date</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.length === 0 ? (
//             <tr>
//               <td colSpan="5" className="text-center text-muted">No bids found.</td>
//             </tr>
//           ) : (
//             data.map((bid, index) => (
//               <tr key={index}>
//                 <td>{bid.id}</td>
//                 <td>{bid.product}</td>
//                 <td>{bid.price}</td>
//                 <td>{bid.createdAt}</td>
//                 <td>{bid.closedAt}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </Table>
//     </div>
//   );
// }

const BidTable = ({ status }) => {
  const [bids, setBids] = useState([]);

  useEffect(() => {
    const fetchBids = async () => {
      const response = await fetch(`https://vyaparapi.emedha.in/api/admin/bids/status/${status}`);
      const data = await response.json();
      setBids(data);
    };
    fetchBids();
  }, [status]);

  return (
    <div style={{ overflowX: 'auto' }}>
      <Table responsive bordered hover>
        <thead className="table-dark">
          <tr>
            <th>Bid ID</th>
            <th>Product Name</th>
            <th>Bid Price</th>
            <th>Created Date</th>
            <th>Closed Date</th>
          </tr>
        </thead>
        <tbody>
          {bids.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center text-muted">No bids found.</td>
            </tr>
          ) : (
            bids.map((bid, index) => (
              <tr key={index}>
                <td>{bid.bid_id}</td>
                <td>{bid.sub_category}</td>
                <td>{bid.price}</td>
                <td>{new Date(bid.created_at).toLocaleDateString()}</td>
                <td>{bid.closedAt ? new Date(bid.closedAt).toLocaleDateString() : 'N/A'}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default function AdminDashboard() {

    const [revenueData, setRevenueData] = useState({});
const [userDistribution, setUserDistribution] = useState([]);


  const [statsData, setStatsData] = useState({
    totalBids: 0,
    totalRevenue: 0,
    totalBuyers: 0,
    totalSellers: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get('https://vyaparapi.emedha.in/api/admin/admin-dashboard-stats');
        setStatsData(res.data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      }
    };

    fetchStats();
  }, []);

  useEffect(() => {
  const fetchCharts = async () => {
    try {
      const [revenueRes, usersRes] = await Promise.all([
        axios.get('https://vyaparapi.emedha.in/api/admin/admin/monthly-revenue'),
        axios.get('https://vyaparapi.emedha.in/api/admin/admin/user-distribution'),
      ]);

      setRevenueData(revenueRes.data);
      setUserDistribution(usersRes.data);
    } catch (error) {
      console.error('Failed to load chart data:', error);
    }
  };

  fetchCharts();
}, []);


  const stats = [
    { title: 'Total Bids',  value: statsData.totalBids.toLocaleString(), icon: <FaGavel size={28} />, bg: '#062d59' },
    { title: 'Total Revenue', value: `₹${statsData.totalRevenue.toLocaleString()}`, icon: <FaDollarSign size={28} />, bg: 'linear-gradient(135deg, #062d59, #274c87)' },
    { title: 'Total Buyers', value: statsData.totalBuyers.toLocaleString(), icon: <FaUsers size={28} />, bg: '#e3080c' },
    { title: 'Total Sellers',  value: statsData.totalSellers.toLocaleString(), icon: <FaUsers size={28} />, bg: 'linear-gradient(135deg, #e3080c, #f14b4e)' },
  ];

 const availableYears = Object.keys(revenueData).sort();
const [selectedYear, setSelectedYear] = useState('');

useEffect(() => {
  if (availableYears.length > 0 && !selectedYear) {
    setSelectedYear(availableYears[availableYears.length - 1]); // set latest year by default
  }
}, [availableYears, selectedYear]);

const selectedYearData = allMonths.map(month => {
  const raw = revenueData[selectedYear] || [];
  const found = raw.find(d => d.name === month);
  return { name: month, value: found ? found.value : 0 };
});

  const pieColors = ['#062d59', '#e3080c'];

  return (
<div style={{
  backgroundColor: '#ffffff',
  minHeight: '100vh',
  paddingTop: '30px',
  paddingBottom: '30px',
  boxShadow: `
    0 0 16px rgba(6, 45, 89, 0.35),    /* #062d59 */
    0 0 12px rgba(227, 8, 12, 0.25)     /* #e3080c */
  `,
  borderRadius: '12px',

}}>

    <Container className="my-1">
      <h3 className="text-center mb-4 fw-bold" style={{ color: '#062d59' }}>
        📊 Admin Dashboard
      </h3>

      {/* Stats Cards */}
      <Row>
        {stats.map((stat, idx) => (
          <Col md={6} lg={3} key={idx} className="mb-4">
            <Card className="text-white border-0 shadow-sm" style={{ background: stat.bg, borderRadius: '15px' }}>
              <Card.Body className="d-flex flex-column justify-content-between p-4" style={{ minHeight: '150px' }}>
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-white text-dark rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 44, height: 44 }}>
                    {stat.icon}
                  </div>
                  <div>
                    <div className="text-uppercase fw-semibold small">{stat.title}</div>
                  </div>
                </div>
                <h4 className="fw-bold d-flex align-items-center justify-content-center">{stat.value}</h4>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Charts Row */}
      <Row  className="shadow-sm border-0 pt-3" style={{ backgroundColor: '#f8f9fc', borderRadius: '12px' }}>
        <Col md={7} className="mb-4">
          <Card className="shadow-sm border-0">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0" style={{ color: '#062d59' }}>
                  📈 Monthly Revenue Trend
                </h5>
                <Form.Select
                  size="sm"
                  style={{ width: '100px' }}
                  value={selectedYear}
                  onChange={e => setSelectedYear(e.target.value)}
                >
                  {availableYears.map(y => <option key={y} value={y}>{y}</option>)}
                </Form.Select>
              </div>

              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={selectedYearData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey="value" stroke="#e3080c" strokeWidth={2} activeDot={{ r: 6 }} />
                </LineChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5} className="mb-4">
          <Card className="shadow-sm border-0">
            <Card.Body>
              <h5 className="fw-bold mb-4" style={{ color: '#062d59' }}>
                <FaUsersCog className="me-2" /> User Distribution
              </h5>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={userDistribution}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={100}
                    label
                  >
                    {userDistribution.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
                    ))}
                  </Pie>
                  <Legend verticalAlign="bottom" height={36} />
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tabs with Bid Table */}
  <Card className="shadow-sm border-0 mt-4">
    <Card.Body>
      <h5 className="fw-bold mb-3" style={{ color: '#062d59' }}>📋 Bid Overview</h5>
      <Tabs defaultActiveKey="all" id="bid-tabs" className="mb-3" justify>
        <Tab eventKey="all" title="All Bids">
          <BidTable status="all" />
        </Tab>
        <Tab eventKey="success" title="Success Bids">
          <BidTable status="accepted" />
        </Tab>
        <Tab eventKey="expired" title="Expired Bids">
          <BidTable status="expired" />
        </Tab>
      </Tabs>
    </Card.Body>
  </Card>
    </Container>
    </div>
  );
}


